import { FC } from "react";
import { ContentfulComponentType } from "../types";
import { AppLevelsAndDiscountsCards } from "./AppLevelsAndDiscountsCards/AppLevelsAndDiscountsCards";
import { Awards } from "./Awards/Awards";
import { ClaimsPageEmailBlock } from "./ClaimsPageEmailBlock/ClaimsPageEmailBlock";
import { HelpYouHelpBlock } from "./HelpYouHelpBlock/HelpYouHelpBlock";
import { LassieInMedia } from "./LassieInMedia/LassieInMedia";
import { TassfondenBlock } from "./TassfondenBlock/TassfondenBlock";
import AppStoreIcons from "./AppStoreIcons/AppStoreIcons";
import InformationIcons from "./InformationIcons";
import PremadeHero from "./PremadeHero";
import ReviewsSection from "./ReviewsSection/ReviewsSection";
import TassfondenAddToCartButton from "./TassfondenAddToCartButton/TassfondenAddToCartButton";
import InsuranceDocuments from "./InsuranceDocuments";
import { SocialLadderLogin } from "./SocialLadderLogin";
import { SocialLadderRegistration } from "./SocialLadderRegistration";
import { WithdrawalForm } from "./WithdrawalForm/WithdrawalForm";

export enum ComponentTypes {
  Trustpilot = "Trustpilot",
  InsuranceDocuments = "Insurance documents",
  Awards = "Awards",
  //Deprecated:
  TrustPilot = "trustPilot",
  AppStoreIcons = "appStoreIcons",
  AppLevelsAndDiscountsCards = "appLevelsAndDiscountsCards",
  ClaimsPageEmailBlock = "claimsPageEmailBlock",
  HelpYouHelpBlock = "helpYouHelpBlock",
  InformationIcons = "informationIcons",
  LassieInMedia = "lassieInMedia",
  TassfondenBlock = "tassfondenBlock",
  TassfondenAddToCartButton = "tassfondenAddToCartButton",
  PremadeHero = "premadeHero",
  SocialLadderLogin = "Social Ladder Login",
  SocialLadderRegistration = "Social Ladder Registration",
  WithdrawalForm = "Withdrawal Form",
}

export const ComponentMap: Record<
  string,
  ContentfulComponentType<any> | FC<any>
> = {
  [ComponentTypes.Trustpilot]: ReviewsSection,
  [ComponentTypes.InsuranceDocuments]: InsuranceDocuments,
  [ComponentTypes.Awards]: Awards,
  [ComponentTypes.TrustPilot]: ReviewsSection,
  [ComponentTypes.ClaimsPageEmailBlock]: ClaimsPageEmailBlock,
  [ComponentTypes.AppLevelsAndDiscountsCards]: AppLevelsAndDiscountsCards,
  [ComponentTypes.TassfondenBlock]: TassfondenBlock,
  [ComponentTypes.InformationIcons]: ({ en, de }) => (
    <InformationIcons de={de} en={en} />
  ),
  [ComponentTypes.HelpYouHelpBlock]: HelpYouHelpBlock,
  [ComponentTypes.LassieInMedia]: LassieInMedia,
  [ComponentTypes.PremadeHero]: PremadeHero,
  [ComponentTypes.AppStoreIcons]: AppStoreIcons,
  [ComponentTypes.SocialLadderLogin]: SocialLadderLogin,
  [ComponentTypes.SocialLadderRegistration]: SocialLadderRegistration,
  [ComponentTypes.WithdrawalForm]: WithdrawalForm,
};

export const RichTextMap: Record<
  string,
  ContentfulComponentType<any> | FC<any>
> = {
  [ComponentTypes.AppStoreIcons]: AppStoreIcons,
  [ComponentTypes.TassfondenAddToCartButton]: TassfondenAddToCartButton,
};
